import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Shield, FileText, Lock } from "lucide-react";

const ICONS = { "brand-agreement": Shield, "model-terms": FileText, privacy: Lock };

/** Generic legal document dialog. doc: 'brand-agreement' | 'model-terms' | 'privacy' */
export const LegalDialog = ({ doc, trigger }) => {
  const [content, setContent] = useState(null);
  const [open, setOpen] = useState(false);
  const Icon = ICONS[doc] || FileText;

  useEffect(() => {
    if (open && !content) {
      api.get(`/legal/${doc}`).then(({ data }) => setContent(data)).catch(() => {});
    }
  }, [open, content, doc]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-xl">
            <Icon className="h-5 w-5 text-[hsl(174,38%,34%)]" />
            {content?.title || "Loading\u2026"}
          </DialogTitle>
          <DialogDescription>{content?.preamble}</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[50vh] pr-4">
          <div className="space-y-4">
            {(content?.clauses || []).map((c, i) => (
              <div key={c.id} className="space-y-1">
                <h4 className="text-sm font-semibold">{i + 1}. {c.title}</h4>
                <p className="text-sm text-muted-foreground">{c.text}</p>
              </div>
            ))}
          </div>
        </ScrollArea>
        {content?.version && (
          <p className="font-mono-plex text-[10px] text-muted-foreground">Version {content.version}</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
